import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getExtensionUnitById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.EXTENSION_UNITS}/${id}`);
    return data;
};

// procedimiento actualizar
export const updateExtensionUnit = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.EXTENSION_UNITS}/${id}`, payload);
    return data;
};